module.exports = __webpack_public_path__ + "img/img_front_bg.984f3fe9.png";